import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";


interface Props extends
	WithStyles<typeof styles>
{
	label: string,
	value: boolean | undefined,
	default?: boolean,
	onOff?: boolean,
	onChange: (value: boolean) => void,
	sidebarNote?: React.ReactNode,
	stacked?: boolean,
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {}, onOff, sidebarNote, stacked } = this.props;
		const value = (this.props.value !== undefined) ? this.props.value : (this.props.default || false); 
		const radioGroup = (
			<Mui.RadioGroup
				row={!stacked}
				className={stacked ? classes.stackedGroup : undefined}
				value={value}
				onChange={event => this.props.onChange((event.target.value === 'true'))}
			>
				<Mui.FormControlLabel
					label={onOff ? "On": "Yes"}
					control={<Mui.Radio />}
					value={true} />
				<Mui.FormControlLabel
					label={onOff ? "Off": "No"}
					control={<Mui.Radio />}
					value={false} />
			</Mui.RadioGroup>
		);
		return (
			<Mui.Grid container direction="row" spacing={2}>
				<Mui.Grid item xs>
					{stacked ? (
						<Mui.Grid container direction="column" spacing={1}>
							<Mui.Grid item>
								<Mui.Typography className={classes.label}>{this.props.label}</Mui.Typography>
							</Mui.Grid>
							<Mui.Grid item>{radioGroup}</Mui.Grid>
						</Mui.Grid>
					) : (
						<Mui.Grid container spacing={3}>
							<Mui.Grid item xs={8}>
								<Mui.Typography className={classes.label}>{this.props.label}</Mui.Typography>
							</Mui.Grid>
							<Mui.Grid item xs={4}>
								{radioGroup}
							</Mui.Grid>
						</Mui.Grid>
					)}
				</Mui.Grid>
				{sidebarNote && (
					<Mui.Grid item xs>
						<Mui.Typography className={classes.labelSpace}>
							<strong>Note:</strong>
							{" "}
							{sidebarNote}
						</Mui.Typography>
					</Mui.Grid>
				)}
			</Mui.Grid>
		);
	}
}

export const YesNoRadioField = withStyles(Component, styles);
